import {
  ACTION_LOAD_WEBMASTER_PROFILE__REQUEST,
  ACTION_LOAD_WEBMASTER_PROFILE__SUCCESS,
  ACTION_LOAD_WEBMASTER_PROFILE__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_WEBMASTER_PROFILE__REQUEST:
    case ACTION_LOAD_WEBMASTER_PROFILE__SUCCESS:
      return null;

    case ACTION_LOAD_WEBMASTER_PROFILE__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
